import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowseSurveyRoutingModule } from './browse-survey-routing.module';
import { BrowseSurveyComponent } from './browse-survey.component';


@NgModule({
  declarations: [
    BrowseSurveyComponent
  ],
  imports: [
    CommonModule,
    BrowseSurveyRoutingModule
  ]
})
export class BrowseSurveyModule { }
